import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();

  useLayoutEffect(() => {
    const scrollTarget = document.scrollingElement || document.documentElement;
    scrollTarget.scrollTo(0, 0);
    document.body.scrollTo(0, 0);

    const root = document.getElementById('root');
    if (root && typeof root.scrollTo === 'function') {
      root.scrollTo(0, 0);
    }
  }, [pathname, search, hash, key]);

  return null;
}
